<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="MyCollect">
      <p class="textTitle">{{ $t("global.我的收藏") }}</p>
      <div class="MyCollectBox clearfix">
        <div class="navLeft">
          <div class="createBox">
            <p class="create clearfix">
              <span class="title1">{{ $t("collect.创建的看单") }}</span
              ><i class="number">{{ createList.length }}</i
              ><span class="title2" @click="gotoSeeLook"
                ><img
                  class="iconImg"
                  src="/static/collect/icon_playlist_info@2x.png"
                  alt=""
                />{{ $t("collect.什么是看单") }}</span
              >
            </p>
            <div
              class="newly"
              @click="cleateLooks"
              @mouseenter="ishoveColor = true"
              @mouseout="ishoveColor = false"
            >
              <img
                v-if="ishoveColor"
                class="iconImg"
                src="/static/collect/icon_add_playlist_hover@2x.png"
                alt=""
              /><img
                v-else
                class="iconImg"
                src="/static/collect/icon_add_playlist@2x.png"
                alt=""
              />{{ $t("collect.新建看单") }}
            </div>
            <div class="lookBox" :class="{ hei: isOpenCreate }">
              <div
                class="lookList"
                v-for="(item, i) in createList"
                :key="i"
                @click="changeLook(item, 1)"
                :class="{ active: activeId == item.id && type == 1 }"
              >
                <img
                  v-if="item.isSecret == 1"
                  class="iconImg"
                  :src="
                    activeId == item.id && type == 1
                      ? '/static/collect/icon_dashboard_playlist_locked_current@2x.png'
                      : '/static/collect/icon_dashboard_playlist_locked@2x.png'
                  "
                  alt=""
                /><img
                  v-else
                  class="iconImg"
                  :src="
                    activeId == item.id && type == 1
                      ? '/static/collect/icon_dashboard_playlist_current@2x.png'
                      : '/static/collect/icon_dashboard_playlist@2x.png'
                  "
                  alt=""
                />{{ item.name }}
                <el-popover
                  placement="right"
                  trigger="hover"
                  :popper-options="{
                    boundariesElement: 'viewport',
                    removeOnDestroy: true,
                  }"
                >
                  <div class="operationTitle">
                    <p class="title1" @click="updateLook(1, item)">
                      {{ $t("collect.编辑信息") }}
                    </p>
                    <p
                      class="title1"
                      v-if="item.isDefault == '1'"
                      @click="deleteCollect(item.id, 1)"
                    >
                      {{ $t("collect.删除") }}
                    </p>
                  </div>
                  <div class="updateBox" slot="reference" @click.stop.prevent>
                    <img
                      class="hoverImg"
                      src="/static/collect/icon_playlist_video_dots@2x.png"
                      alt=""
                    />
                  </div>
                </el-popover>
              </div>
            </div>
            <div
              class="openAll"
              v-if="createList.length > 5 && !isOpenCreate"
              @click="isOpenCreate = true"
            >
              <img src="" alt="" />{{ $t("collect.展开全部") }}
            </div>
            <div
              class="openAll"
              v-if="createList.length > 5 && isOpenCreate"
              @click="isOpenCreate = false"
            >
              <img src="" alt="" />{{ $t("collect.收起") }}
            </div>
          </div>
          <div class="collectionBox">
            <p class="title">
              <span>{{ $t("collect.收藏的看单") }}</span
              ><i class="number">{{ collectList.length }}</i>
            </p>
            <div class="lookBox" :class="{ hei1: isOpenCollect }">
              <div
                class="lookList"
                v-for="(item, i) in collectList"
                :key="i"
                @click="changeLook(item, 2)"
                :class="{
                  active: activeId == item.id && type == 2,
                  col: item.isSecret == 1 || item.isDelete == 1,
                }"
              >
                <img
                  v-if="item.isSecret == 1 || item.isDelete == 1"
                  class="iconImg"
                  :src="
                    item.isSecret == 1
                      ? '/static/collect/icon_dashboard_playlist_locked_disabled@2x.png'
                      : '/static/collect/icon_playlist_deleteded_disabled@2x.png'
                  "
                  alt=""
                /><img
                  v-else
                  class="iconImg"
                  :src="
                    activeId == item.id && type == 2
                      ? '/static/collect/icon_dashboard_playlist_current@2x.png'
                      : '/static/collect/icon_dashboard_playlist@2x.png'
                  "
                  alt=""
                />{{
                  item.isSecret == 1
                    ? $t("collect.此看单已被设置为私密")
                    : item.isDelete == 1
                    ? $t("collect.此看单已被删除")
                    : item.name
                }}
                <el-popover
                  placement="right"
                  trigger="hover"
                  :popper-options="{
                    boundariesElement: 'viewport',
                    removeOnDestroy: true,
                  }"
                >
                  <div class="operationTitle">
                    <p class="title1" @click="deleteCollect(item.id, 2)">
                      {{ $t("collect.取消收藏") }}
                    </p>
                  </div>
                  <div class="updateBox" slot="reference" @click.stop.prevent>
                    <img
                      class="hoverImg"
                      src="/static/collect/icon_playlist_video_dots@2x.png"
                      alt=""
                    />
                  </div>
                </el-popover>
              </div>
            </div>
            <div
              class="openAll"
              v-if="collectList.length > 5 && !isOpenCollect"
              @click="isOpenCollect = true"
            >
              <img src="" alt="" />{{ $t("collect.展开全部") }}
            </div>
            <div
              class="openAll"
              v-if="collectList.length > 5 && isOpenCollect"
              @click="isOpenCollect = false"
            >
              <img src="" alt="" />{{ $t("collect.收起") }}
            </div>
          </div>
          <div class="acritleBox" @click="changeLook(null, 3)">
            <p class="title">
              <span :class="{ clickColor: type == 3 }">{{
                $t("collect.文章")
              }}</span
              ><i class="number">{{ acritleNumber }}</i>
            </p>
          </div>
          <div class="acritleBox" @click="changeLook(null, 4)">
            <p class="title">
              <span :class="{ clickColor: type == 4 }">{{
                $t("collect.活动")
              }}</span
              ><i class="number">{{ activityNumber }}</i>
            </p>
          </div>
        </div>
        <div class="rightBox">
          <div
            class="message"
            v-if="videoDetails[0] && videoDetails[0].status !== 1"
          >
            {{ $t("collect.当前看单审核不通过") }}：{{
              videoDetails[0].rejection
            }}
          </div>
          <div v-if="type == 1 || type == 2">
            <div class="lookText">
              <div class="text clearfix" v-if="videoDetails[0]">
                <div class="imgBox">
                  <img
                    class="imgIcon"
                    :src="
                      videoDetails[0].thumb
                        | imageUrl('/static/collect/default.png', 320, 180)
                    "
                    alt=""
                  />
                  <img
                    class="videoImg"
                    src="/static/collect/icon_playlist_corner@2x.png"
                    alt=""
                  />
                </div>
                <div class="infoBox">
                  <p class="name clearfix">
                    <span class="text1" @click="gotoLook(videoDetails[0].id)">{{
                      videoDetails[0].name
                    }}</span
                    ><span
                      class="update"
                      @click="updateLook(2)"
                      v-if="type == 1"
                      ><img
                        class="editIcon"
                        src="/static/collect/edit_icon@2x.png"
                        alt=""
                      />{{ $t("collect.编辑") }}</span
                    >
                  </p>
                  <p
                    class="nick"
                    @click.stop.prevent="gotoRouter(videoDetails[0].userId)"
                  >
                    {{ $t("collect.创建者") }}：{{ videoDetails[0].nickName }}
                  </p>
                  <p class="number">
                    {{ videoDetails[0].videoCount || 0
                    }}{{ $t("collect.个视频") }} ·
                    {{
                      videoDetails[0].isSecret == 1
                        ? $t("collect.私密")
                        : $t("collect.公开")
                    }}
                  </p>
                </div>
                <div class="buttonBox" v-if="videoList.length">
                  <div class="play" @click="gotoVideo(videoDetails[0].id)">
                    <img
                      class="playIcon"
                      src="/static/collect/icon_playlist_hover_playall@2x.png"
                      alt=""
                    />{{ $t("collect.播放全部") }}
                  </div>
                  <el-popover placement="bottom" width="240px" trigger="hover">
                    <share :config="config"></share>
                    <span class="bottom" slot="reference">{{
                      $t("global.分享")
                    }}</span>
                  </el-popover>
                </div>
              </div>
            </div>
            <CollectVideoList
              v-if="videoDetails[0] && videoDetails[0].videoCount > 0"
              :list="videoList"
              :id="id"
              @getList="getList"
            />
            <div v-else class="noDataBox">
              <img
                class="nodataImg"
                src="/static/newSearch/video_empty@2x.png"
                alt=""
              />
              <p class="nodataTitle">{{ $t("collect.该看单暂无内容") }}</p>
            </div>
          </div>

          <CollectAcritle
            v-if="type == 3 && videoList.length"
            :list="videoList"
            :index="acritleNumber"
            @getList="getList"
          />
          <div v-else-if="type == 3" class="noDataBox">
            <img
              class="nodataImg"
              src="/static/newSearch/article_empty@2x.png"
              alt=""
            />
            <p class="nodataTitle">{{ $t("collect.暂无收藏的文章") }}</p>
          </div>
          <CollectActivity
            v-if="type == 4 && videoList.length"
            :list="videoList"
            :index="activityNumber"
            @getList="getList"
          />
          <div v-else-if="type == 4" class="noDataBox">
            <img
              class="nodataImg"
              src="/static/newSearch/event_empty@2x.png"
              alt=""
            />
            <p class="nodataTitle">{{ $t("collect.暂无收藏的活动") }}</p>
          </div>
          <Loading v-if="loading" />
          <Reload v-if="loadError" @callback="loadMore" />
          <no-more v-if="!hasNextPage && videoList.length" />
        </div>
      </div>
      <div class="createPop" v-if="cleateLookPop">
        <div class="popBox">
          <p class="title">
            {{
              typePop == 1
                ? $t("collect.新建看单")
                : $t("collect.编辑看单信息")
            }}<img
              class="close"
              @click="cleateLookPop = false"
              src="/static/close_btn@2x.png"
              alt=""
            />
          </p>
          <div class="from">
            <p class="name"><i>*</i>{{ $t("collect.看单名称") }}</p>
            <div class="text">
              <input
                v-model="nametext"
                type="text"
                :placeholder="$t('collect.请输入名称')"
              /><span class="numLen">{{ nametext.length }}/40</span>
            </div>
            <p class="name"><i>*</i>{{ $t("collect.是否公开") }}</p>
            <div class="select clearfix">
              <div class="left" @click="isSecret = 0">
                <span class="circular" :class="{ cirColor: isSecret == 0 }"
                  ><i v-if="isSecret == 0"></i></span
                >{{ $t("collect.公开") }}
              </div>
              <div class="right" @click="isSecret = 1">
                <span class="circular" :class="{ cirColor: isSecret == 1 }"
                  ><i v-if="isSecret == 1"></i></span
                >{{ $t("collect.私密") }}
              </div>
            </div>
          </div>
          <div class="buttom">
            <span class="cel" @click="cleateLookPop = false">{{
              $t("collect.取消")
            }}</span
            ><span class="determineCir" @click="saveLook">{{
              $t("collect.确定")
            }}</span>
          </div>
        </div>
      </div>
      <div class="createPop" v-if="deleteBox">
        <div class="popBox popBox1">
          <p class="title">
            <span class="title1">{{
              deleType == 1 ? $t("collect.删除看单") : $t("collect.取消收藏")
            }}</span>
          </p>
          <p class="textTitle">
            {{
              deleType == 1
                ? $t("collect.是否删除该看单？")
                : $t("collect.是否取消收藏该看单？")
            }}
          </p>
          <div class="buttom buttom2">
            <div class="butBox">
              <span class="cel" @click="deleteBox = false">{{
                $t("collect.否")
              }}</span
              ><span class="determineCir" @click="deleteTrue">{{
                $t("collect.是")
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import Share from "@/components/v2/Share";
import { imageUrl } from "@/util/filters.js";
import CollectVideoList from "@/components/collect/collectVideoList";
import CollectAcritle from "@/components/collect/CollectAcritle";
import CollectActivity from "@/components/collect/CollectActivity";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight,
} from "@/assets/screen";
export default {
  name: "MyCollect",
  metaInfo() {
    return {
      title: this.$t("global.我的收藏") + " | MANA",
    };
  },
  data() {
    return {
      createList: [],
      collectList: [],
      nametext: "",
      isSecret: 0,
      cleateLookPop: false,
      isOpenCreate: false,
      isOpenCollect: false,
      config: {},
      id: null,
      type: 1,
      activeId: null,
      videoListIndex: 1,
      videoListSize: 18,
      videoList: [],
      videoDetails: {},
      typePop: null,
      ishoveColor: false,
      collectId: null,
      deleteBox: false,
      loading: false,
      loadError: false,
      hasNextPage: false,
      acritleNumber: 0,
      activityNumber: 0,
      deleType: null,
    };
  },
  components: {
    MainLayout,
    service,
    Share,
    CollectVideoList,
    CollectAcritle,
    CollectActivity,
    Reload,
    NoMore,
    Loading,
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
    window.addEventListener("scroll", this.toggleTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
    window.removeEventListener("scroll", this.toggleTop, false);
  },
  methods: {
    init() {
      (this.isOpenCreate = false),
        (this.isOpenCollect = false),
        (this.videoListIndex = 1);
      this.videoListSize = 18;
      this.activeId = null;
      this.id = null;
      this.videoList = [];
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
        if (this.type == 3 || this.type == 4) {
          this.getCollectVideoList();
        }
      }
      this.getUfavList();
      this.getUfavCollectList();
      this.getActivityNumber();
      this.getAcritleNumber();
    },
    gotoRouter(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
    toggleTop() {
      const left = document.querySelector(".MyCollectBox .navLeft");
      const right = document.querySelector(".MyCollectBox .rightBox");
      const leftOffsetHeight = left.offsetHeight;
      const rightOffsetHeight = right.offsetHeight;
      const windowHeight = document.querySelector("html").offsetHeight;
      const scrollTop = document.querySelector("html").scrollTop;
      const bodyOffsetHeight = document.querySelector(".body").offsetHeight;
      let isTop = windowHeight - 86 > leftOffsetHeight;
      if (leftOffsetHeight < windowHeight - 280 - 86 && scrollTop > 70) {
        left.classList.add("float2");
        left.style.transform = `translateY(0)`;
      } else if (leftOffsetHeight < rightOffsetHeight && scrollTop > 70) {
        if (
          leftOffsetHeight + 240 < windowHeight &&
          scrollTop > 130 &&
          scrollTop < bodyOffsetHeight - windowHeight - 160
        ) {
          if (isTop) {
            left.classList.add("float2");
            left.style.transform = `translateY(0)`;
          } else {
            left.classList.add("float1");
            left.style.transform = `translateY(0)`;
          }
        } else if (
          windowHeight +
            scrollTop -
            left.getBoundingClientRect().top -
            leftOffsetHeight -
            86 >
          0
        ) {
          if (!isTop) {
            left.classList.add("float1");
            left.style.transform = `translateY(0)`;
          }
        }
        if (scrollTop >= 70) {
          if (scrollTop + windowHeight + 220 >= rightOffsetHeight + 410) {
            if (leftOffsetHeight + scrollTop > rightOffsetHeight) {
              if (!isTop) {
                left.classList.remove("float1");
                left.style.transform = `translateY(${
                  rightOffsetHeight - leftOffsetHeight
                }px)`;
              } else {
                left.classList.remove("float2");
                left.style.transform = `translateY(${
                  rightOffsetHeight - leftOffsetHeight
                }px)`;
              }
            } else if (
              scrollTop + windowHeight >=
              rightOffsetHeight + 410 + 160
            ) {
              if (isTop) {
                left.classList.remove("float2");
                left.style.transform = `translateY(0)`;
              } else {
                left.classList.remove("float1");
                left.style.transform = `translateY(0)`;
              }
              // left.style.transform = `translateY(${
              //   rightOffsetHeight - windowHeight + 250 + 160
              // }px)`;
            } else if (
              scrollTop + windowHeight >= rightOffsetHeight + 410 &&
              leftOffsetHeight + 240 < bodyOffsetHeight - 160 - scrollTop
            ) {
              if (isTop) {
                left.classList.remove("float2");
                left.style.transform = `translateY(0)`;
              } else {
                left.classList.remove("float1");
                left.style.transform = `translateY(0)`;
              }
              // left.style.transform = `translateY(${scrollTop - 160}px)`;
            }
          } else if (leftOffsetHeight + 370 >= windowHeight + scrollTop) {
            if (isTop) {
              left.classList.remove("float2");
              left.style.transform = `translateY(0)`;
            } else {
              left.classList.remove("float1");
              left.style.transform = `translateY(0)`;
            }
            // left.style.transform = `translateY(0)`;
          }
        } else {
          if (
            windowHeight +
              scrollTop -
              left.getBoundingClientRect().top -
              leftOffsetHeight -
              86 <
            0
          ) {
            if (isTop) {
              left.classList.remove("float2");
              left.style.transform = `translateY(0)`;
            } else {
              left.classList.remove("float1");
              left.style.transform = `translateY(0)`;
            }
            // left.style.transform = `translateY(0)`;
          }
        }
      } else {
        if (isTop) {
          left.classList.remove("float2");
          left.style.transform = `translateY(0)`;
        } else {
          left.classList.remove("float1");
          left.style.transform = `translateY(0)`;
        }
      }
    },
    gotoSeeLook() {
      let routeData = this.$router.resolve({ path: "/treaty/3349" });
      window.open(routeData.href, "_blank");
    },
    gotoLook(id) {
      let routeData = this.$router.resolve({ path: "/playlist/" + id });
      window.open(routeData.href, "_blank");
    },
    gotoVideo(id) {
      if (this.videoList.length) {
        let routeData = this.$router.resolve({
          path: "/video/detail?id=" + this.videoList[0].id + "&lookId=" + id,
        });
        window.open(routeData.href, "_blank");
      }
    },
    getAcritleNumber() {
      let params = {
        questionType: 0,
        type: 3,
        pageIndex: 1,
        pageSize: 10,
      };
      this.$http
        .get("/api/u/topicquestion/getMyCollectionQuestion", { params })
        .then((res) => {
          this.acritleNumber = res.data.totalRecord;
        });
    },
    getActivityNumber() {
      let params = {
        pageIndex: 1,
        pageSize: 10,
      };
      this.$http
        .get("/api/u/activity/myCollectionActivity", { params })
        .then((res) => {
          this.activityNumber = res.data.totalRecord;
        });
    },
    updateLook(type, item) {
      if (type == 1) {
        this.typePop = 3;
        this.collectId = item.id;
        this.nametext = item.name;
        this.isSecret = item.isSecret;
      }
      if (type == 2) {
        this.typePop = 2;
        this.nametext = this.videoDetails[0].name;
        this.isSecret = this.videoDetails[0].isSecret;
      }
      this.cleateLookPop = true;
    },
    deleteCollect(id, index) {
      this.deleteBox = true;
      this.collectId = id;
      this.deleType = index;
    },
    deleteTrue() {
      let url = "";
      if (this.deleType == 1) {
        url = "/api/u/fav/" + this.collectId;
      }
      if (this.deleType == 2) {
        url = "/api/u/fav/collect/" + this.collectId;
      }
      this.$http.delete(url).then((res) => {
        if (res.code === "OK") {
          this.$message.success(res.message);
          this.deleteBox = false;
          // this.$router.push("/MyCollect");
          this.init();
        }
      });
    },
    getList() {
      this.videoListIndex = 1;
      this.getCollectVideoList();
    },
    getCollectVideoList() {
      this.loading = true;
      let params = {};
      let url = null;
      if (this.type == 1 || this.type == 2) {
        url = "/api/u/fav/collectVideoList/" + this.id;
        params = {
          id: this.id,
          pageIndex: this.videoListIndex,
          pageSize: this.videoListSize,
        };
      }
      if (this.type == 3) {
        url = "/api/u/topicquestion/getMyCollectionQuestion";
        params = {
          questionType: 0,
          type: 3,
          pageIndex: this.videoListIndex,
          pageSize: 10,
        };
      }
      if (this.type == 4) {
        url = "/api/u/activity/myCollectionActivity";
        params = {
          pageIndex: this.videoListIndex,
          pageSize: 9,
        };
      }
      this.$http.get(url, { params }).then((res) => {
        this.loading = false;
        if (res.code === "OK") {
          if (this.videoListIndex === 1) {
            this.videoList = [];
          }
          this.loadError = false;
          this.videoList = [...this.videoList, ...res.data.list];
          this.hasNextPage = res.data.hasNextPage;
          if (this.type == 3) {
            this.acritleNumber = res.data.totalRecord;
          }
          if (this.type == 4) {
            this.activityNumber = res.data.totalRecord;
          }
        } else {
          if (this.videoListIndex !== 1) {
            this.videoListIndex--;
          }
          this.loadError = true;
        }
      });
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 500) {
        if (!this.loading && this.hasNextPage && this.id) {
          this.videoListIndex++;
          this.getCollectVideoList();
        }
      }
    },
    getUfavList() {
      this.$http.get("/api/u/fav/createList").then((res) => {
        if (res.code === "OK") {
          this.createList = res.data;
          if (this.$route.query.id && this.type == 1) {
            this.id = this.$route.query.id;
            this.activeId = this.$route.query.id;
          } else if (this.type == 1) {
            this.id = this.createList[0].id;
            this.activeId = this.createList[0].id;
          }
          if (this.type == 1) {
            if (this.createList.length > 5) {
              let ids = [];
              for (let i = 0; i < this.createList.slice(0, 5).length; i++) {
                ids.push(this.createList[i].id);
              }
              let index = ids.indexOf(this.id);
              if (index == -1) {
                this.isOpenCreate = true;
              }
            }
            this.videoDetails = this.createList.filter((item) => {
              return item.id == this.id;
            });
            this.config = {
              share_url: location.host + "/playlist/" + this.id,
              title: "MANA | " + this.videoDetails[0].name,
              desc: "MANA " + this.$t("global.全球新媒体艺术平台"),
              pics: imageUrl(this.videoDetails[0].thumb),
            };
            if (
              this.id &&
              this.videoDetails &&
              this.videoDetails[0].videoCount &&
              this.videoDetails[0].videoCount > 0
            ) {
              this.getCollectVideoList();
            }
          }
        }
      });
    },
    getUfavCollectList() {
      this.$http.get("/api/u/fav/collectList").then((res) => {
        if (res.code === "OK") {
          this.collectList = res.data;
          if (this.$route.query.id && this.type == 2) {
            this.id = this.$route.query.id;
            this.activeId = this.$route.query.id;
          } else if (this.type == 2) {
            this.id = this.collectList[0].id;
            this.activeId = this.collectList[0].id;
          }
          if (this.type == 2) {
            if (this.collectList.length > 5) {
              let ids = [];
              for (let i = 0; i < this.collectList.slice(0, 5).length; i++) {
                ids.push(this.collectList[i].id);
              }
              let index = ids.indexOf(this.id);
              if (index == -1) {
                this.isOpenCollect = true;
              }
            }
            this.videoDetails = this.collectList.filter((item) => {
              return item.id == this.id;
            });
            this.config = {
              share_url: location.host + "/playlist/" + this.id,
              title: "MANA | " + this.videoDetails[0].name,
              desc: "MANA " + this.$t("global.全球新媒体艺术平台"),
              pics: imageUrl(this.videoDetails[0].thumb),
            };
            if (
              this.id &&
              this.videoDetails &&
              this.videoDetails[0].videoCount &&
              this.videoDetails[0].videoCount > 0
            ) {
              this.getCollectVideoList();
            }
          }
        }
      });
    },
    cleateLooks() {
      this.nametext = "";
      this.isSecret = 0;
      this.cleateLookPop = true;
      this.typePop = 1;
    },
    changeLook(item, type) {
      if (type == 1 || type == 2) {
        if (type == 2 && (item.isSecret == 1 || item.isDelete == 1)) {
          return;
        }
        this.activeId = item.id;
        this.$router.push("/MyCollect" + "?id=" + item.id + "&type=" + type);
      }
      if (type == 3 || type == 4) {
        this.$router.push("/MyCollect" + "?type=" + type);
      }
    },
    saveLook() {
      if (!this.nametext.replace(/[\r\n\s]/g, "")) {
        this.$message.warning(this.$t("collect.名称不能为空！"));
        return;
      }
      let form = {};
      if (this.typePop == 1) {
        form = {
          name: this.nametext,
          isSecret: this.isSecret,
        };
        this.$http
          .post("/api/u/fav/", form, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.code === "OK") {
              this.cleateLookPop = false;
              this.$message.success(res.message);
              this.getUfavList();
            }
          });
      } else if (this.typePop == 2 || this.typePop == 3) {
        form = {
          id: this.typePop == 2 ? this.videoDetails[0].id : this.collectId,
          name: this.nametext,
          isSecret: this.isSecret,
        };
        this.$http
          .put("/api/u/fav/", form, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.code === "OK") {
              this.cleateLookPop = false;
              this.$message.success(res.message);
              this.getUfavList();
            }
          });
      }
    },
  },
  watch: {
    nametext(newVal, oldVal) {
      if (newVal && newVal.length > 40) {
        this.nametext = oldVal;
      }
    },
    $route(to) {
      this.init();
    },
  },
};
</script>
<style>
.el-popover {
  min-width: auto;
  padding: 10px 0;
}
.operationTitle .title1 {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  text-align: center;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  cursor: pointer;
}
.operationTitle .title1:hover {
  background: #f5f5f5;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.MyCollect {
  padding-top: 40px;
  padding-bottom: 120px;
  position: relative;

  .textTitle {
    width: 1110px;
    margin: 0 auto 24px;
    height: 36px;
    font-size: 24px;
    font-weight: 600;
    color: #0A0A0A;
    line-height: 36px;
  }

  .MyCollectBox {
    width: 1110px;
    margin: 0 auto;
    position: relative;

    .navLeft {
      float: left;
      margin-right: 30px;
      width: 255px;
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      box-sizing: border-box;
      cursor: pointer;

      .createBox {
        border-bottom: 1px solid #EBEBEB;
        padding: 16px 0 10px 0;
        box-sizing: border-box;

        .create {
          margin-bottom: 12px;
          padding: 0 16px 0 24px;
          box-sizing: border-box;

          .title1 {
            height: 23px;
            font-size: 15px;
            font-weight: 600;
            color: #333333;
            line-height: 23px;
          }

          .number {
            height: 21px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 21px;
            margin-left: 4px;
          }

          .title2 {
            float: right;
            height: 18px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(32, 38, 204, 0.85);
            line-height: 24px;

            .iconImg {
              width: 14px;
              height: 14px;
              margin-right: 4px;
              vertical-align: text-bottom;
            }
          }
        }

        .newly {
          height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: #333;
          line-height: 40px;
          padding: 0 16px 0 24px;
          box-sizing: border-box;

          &:hover {
            color: #3664ED;
          }

          .iconImg {
            width: 20px;
            height: 20px;
            margin-right: 6px;
            vertical-align: text-bottom;
          }
        }

        .lookBox {
          max-height: 200px;
          overflow: hidden;

          .lookList {
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            color: #333;
            line-height: 40px;
            padding: 0 16px 0 24px;
            box-sizing: border-box;
            position: relative;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;

            .iconImg {
              width: 20px;
              height: 20px;
              margin-right: 6px;
              vertical-align: text-bottom;
            }

            .updateBox {
              position: absolute;
              right: 12px;
              top: 0;
              display: none;
              height: 40px;

              .hoverImg {
                width: 20px;
                height: 20px;
              }
            }

            &:hover {
              background: #F5F5F5;

              .updateBox {
                display: block;
              }
            }
          }

          .active {
            font-weight: 600;
            color: #2026CC;
          }
        }

        .hei {
          max-height: inherit;
        }

        .openAll {
          height: 40px;
          line-height: 40px;
          padding: 0 16px 0 24px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
      }

      .collectionBox {
        padding-top: 16px;
        box-sizing: border-box;

        .title {
          height: 23px;
          font-size: 15px;
          font-weight: 600;
          color: #333333;
          line-height: 23px;
          padding: 0 16px 0 24px;
          box-sizing: border-box;
          margin-bottom: 12px;

          .number {
            height: 21px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 21px;
            margin-left: 4px;
          }
        }

        .lookBox {
          max-height: 200px;
          overflow: hidden;

          .lookList {
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            color: #333;
            line-height: 40px;
            padding: 0 16px 0 24px;
            box-sizing: border-box;
            position: relative;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;

            .iconImg {
              width: 20px;
              height: 20px;
              margin-right: 6px;
              vertical-align: text-bottom;
            }

            .updateBox {
              position: absolute;
              right: 12px;
              top: 0;
              display: none;
              height: 40px;

              .hoverImg {
                width: 20px;
                height: 20px;
              }
            }

            &:hover {
              background: #F5F5F5;

              .updateBox {
                display: block;
              }
            }
          }

          .active {
            font-weight: 600;
            color: #2026CC;
          }

          .col {
            font-weight: 400;
            color: #999999;
            cursor: no-drop;
          }
        }

        .hei1 {
          max-height: inherit;
        }

        .openAll {
          height: 40px;
          line-height: 40px;
          padding: 0 16px 0 24px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
      }

      .acritleBox {
        border-top: 1px solid #EBEBEB;
        box-sizing: border-box;

        .title {
          height: 54px;
          font-size: 15px;
          font-weight: 600;
          color: #333333;
          line-height: 54px;
          padding: 0 16px 0 24px;
          box-sizing: border-box;

          .number {
            height: 21px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 21px;
            margin-left: 4px;
          }

          .clickColor {
            color: #2026CC;
          }
        }
      }

      &.float {
        position: fixed;
        top: 66px;
      }

      &.float1 {
        position: fixed;
        bottom: 20px;
      }

      &.float2 {
        position: fixed;
        top: 86px;
      }
    }

    .rightBox {
      float: right;
      width: 825px;
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      box-sizing: border-box;
      padding: 40px 0;
      min-height: 500px;
      position: relative;

      .message {
        position: absolute;
        top: -60px;
        left: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: rgba(254, 86, 48, 0.1);
        text-align: center;
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #FE5630;
      }

      .lookText {
        position: relative;
        padding: 0 36px;

        .text {
          padding-bottom: 30px;
          border-bottom: 1px solid #EBEBEB;

          .imgBox {
            float: left;
            width: 160px;
            height: 90px;
            margin-right: 20px;
            position: relative;

            .imgIcon {
              width: 100%;
              height: 100%;
            }

            .videoImg {
              position: absolute;
              width: 28px;
              height: 28px;
              right: 0;
              bottom: 0;
            }
          }

          .infoBox {
            float: left;
            padding-top: 5px;
            margin-right: 20px;

            .name {
              .text1 {
                float: left;
                max-width: 390px;
                line-height: 24px;
                font-size: 16px;
                font-weight: 600;
                color: #0A0A0A;
                margin-right: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-word;
                cursor: pointer;
              }

              .update {
                float: left;
                vertical-align: middle;
                width: 60px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: rgba(54, 100, 237, 0.09);
                font-size: 14px;
                font-weight: 400;
                color: #3664ED;
                cursor: pointer;

                .editIcon {
                  width: 12px;
                  height: 12px;
                  vertical-align: initial;
                  margin-right: 3px;
                }
              }
            }

            .nick {
              height: 20px;
              font-size: 13px;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
              margin: 8px 0;
              width: 470px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            }

            .number {
              height: 20px;
              font-size: 13px;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }
          }

          .buttonBox {
            position: absolute;
            bottom: 30px;
            left: 400px;

            .play {
              display: inline-block;
              padding: 0 20px 0 16px;
              height: 32px;
              background: #1C21B0;
              line-height: 32px;
              text-align: center;
              font-size: 14px;
              font-weight: 600;
              color: #FFFFFF;
              margin-right: 10px;
              cursor: pointer;
              vertical-align: middle;

              .playIcon {
                width: 16px;
                height: 16px;
                margin-right: 4px;
              }
            }

            .bottom {
              display: inline-block;
              width: 90px;
              height: 32px;
              line-height: 32px;
              text-align: center;
              border: 1px solid #2026CC;
              font-size: 14px;
              font-weight: 600;
              color: #2026CC;
              box-sizing: border-box;
              cursor: pointer;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  .createPop {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9999;

    .popBox {
      width: 445px;
      height: 362px;
      background: rgba(255, 255, 255, 1);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .title {
        height: 60px;
        line-height: 60px;
        padding-left: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        position: relative;
        border-bottom: 1px solid #E0E0E0;

        .close {
          position: absolute;
          right: 24px;
          top: 23px;
          width: 13px;
          height: 13px;
          cursor: pointer;
        }
      }

      .from {
        padding: 20px 24px 0;

        .name {
          font-size: 15px;
          font-weight: 600;
          color: #333;

          i {
            color: #FE5630;
          }
        }

        .text {
          width: 100%;
          height: 40px;
          margin: 12px 0 20px 0;
          position: relative;

          input {
            display: inline-block;
            width: 100%;
            height: 40px;
            border: 1px solid #E0E0E0;
            padding: 0 50px 0 15px;
            box-sizing: border-box;

            &:focus {
              border: 1px solid #2026CC;
            }
          }

          .numLen {
            position: absolute;
            font-size: 14px;
            font-weight: 400;
            color: #E0E0E0;
            right: 10px;
            height: 21px;
            top: 10px;
            line-height: 21px;
          }
        }

        .select {
          margin-top: 15px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;

          .left {
            float: left;
            margin-right: 30px;
            cursor: pointer;
          }

          .right {
            float: left;
            cursor: pointer;
          }

          .circular {
            display: inline-block;
            width: 20px;
            height: 20px;
            border: 1px solid #B8B8B8;
            border-radius: 50%;
            vertical-align: middle;
            margin-right: 10px;
            position: relative;
            box-sizing: border-box;
            vertical-align: middle;

            i {
              position: absolute;
              width: 10px;
              height: 10px;
              background: #2026CC;
              border-radius: 50%;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .cirColor {
            border: 1px solid #2026CC;
          }
        }
      }

      .buttom {
        margin-top: 60px;
        text-align: center;

        .cel {
          width: 90px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          margin-right: 20px;
          vertical-align: middle;
          font-size: 14px;
          font-weight: 600;
          border: 1px solid #999999;
          color: #333333;
          cursor: pointer;
        }

        .determineCir {
          background: #2026CC;
          color: #FFFFFF;
          box-sizing: border-box;
          display: inline-block;
          width: 90px;
          height: 30px;
          line-height: 30px;
          vertical-align: middle;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
        }
      }
    }

    .popBox1 {
      height: 220px;
      width: 380px;

      .textTitle {
        width: 380px;
        height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        text-align: center;
        margin: 27px 0 32px 0;
      }

      .buttom2 {
        border-top: none;
      }
    }
  }
}

.noDataBox {
  text-align: center;
  padding: 60px 0;

  .nodataImg {
    width: 88px;
    height: 88px;
    margin-bottom: 10px;
  }

  .nodataTitle {
    height: 21px;
    font-size: 15px;
    font-weight: 400;
    color: #B8B8B8;
    line-height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/Collect.vue